import { Customer } from 'shopify-types'

import type { CustomerFieldsFragment } from '../__generated/storefront'
import { type GQLClubBenefitNode, mapGQLClubBenefit } from '../metaobject/clubBenefit'
import { mapGQLAddressToAddress } from './address/graphql'
import { mapGQLOrderToOrder } from './order/graphql'

export type GQLCustomer = CustomerFieldsFragment

const getClubBenefitNodes = (
  references:
    | {
        nodes?: Array<GQLClubBenefitNode | Record<PropertyKey, never>>
      }
    | null
    | undefined,
) => (references?.nodes ?? []) as GQLClubBenefitNode[]

export const mapGQLCustomerToCustomer = (customer: GQLCustomer): Customer => ({
  id: customer.id,
  email: customer.email ?? '',
  phone: customer.phone ?? undefined,
  firstName: customer.firstName ?? '',
  lastName: customer.lastName ?? '',
  defaultAddress: customer.defaultAddress
    ? mapGQLAddressToAddress(customer.defaultAddress)
    : undefined,
  addresses: customer.addresses.edges.map(address => mapGQLAddressToAddress(address.node)),
  orders: customer.orders.edges.map(order => mapGQLOrderToOrder(order.node)),
  points: customer.points ? parseInt(customer.points.value ?? 0) : 0,
  pointsExpiring: customer.pointsExpiring ? parseInt(customer.pointsExpiring.value ?? 0) : 0,
  benefitsIndividual: getClubBenefitNodes(customer.benefitsIndividual?.references).map(
    mapGQLClubBenefit,
  ),
  benefitsOnetime: getClubBenefitNodes(customer.benefitsOnetime?.references).map(mapGQLClubBenefit),
  benefitsUsed: getClubBenefitNodes(customer.benefitsUsed?.references).map(mapGQLClubBenefit),
  tags: customer.tags ?? [],
})
